import { render, staticRenderFns } from "./newAccount.vue?vue&type=template&id=261b18e9&"
import script from "./newAccount.vue?vue&type=script&lang=js&"
export * from "./newAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports